import { defineComponent } from 'vue';
import recognition from '@/auth/recognition';
import { Modal } from './type';

export const HasTaskMixin = defineComponent({
  data(): { task: Promise<any>|null, isLoading: boolean } {
    return {
      task: null,
      isLoading: false,
    };
  },
  watch: {
    task(task: Promise<any>) {
      this.isLoading = true;
      task.finally(() => {
        this.isLoading = false;
      });
    },
  },
});

export const ModalMixin = defineComponent({
  emits: ['ok'],
  methods: {
    show() {
      (this.$refs.modal as Modal).show();
    },
    hide() {
      (this.$refs.modal as Modal).hide();
    },
    onOKClick(payload: any) {
      this.$emit('ok', payload);
    },
  },
});

export const AccountContextMixin = defineComponent({
  props: {
    accountId: {
      type: Number,
      default() {
        return recognition.getAccountId();
      },
    },
  },
});

export const UserContextMixin = defineComponent({
  props: {
    userId: {
      type: Number,
      default() {
        return recognition.getUserId();
      },
    },
  },
});

export const PaginationMixin = defineComponent({
  emits: ['update:modelValue'],
  props: {
    total: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    size: {
      type: String,
      default: '1rem',
    },
  },
  computed: {
    numPages(): number {
      return Math.ceil(this.total / this.perPage);
    },
    start(): number {
      return ((this.modelValue - 1) * this.perPage) + 1;
    },
    end(): number {
      const end = this.start + (this.perPage - 1);
      return (end > this.total) ? this.total : end;
    },
    offset(): number {
      return (this.modelValue - 1) * this.perPage;
    },
    statusText(): string {
      if (this.start === this.end) {
        return `Showing ${this.start} of ${this.total}`;
      }
      return `Showing ${this.start} - ${this.end} of ${this.total}`;
    },
  },
  methods: {
    prevPage(): void {
      this.changePage(this.modelValue - 1);
    },
    nextPage(): void {
      this.changePage(this.modelValue + 1);
    },
    changePage(newPage: number): void {
      this.$emit('update:modelValue', newPage);
    },
  },
});
